<template lang="pug">
portal(to="v-main")
  .instruction
    v-chip.instruction__trigger-open(
      v-if="triggerVisible"
      color="secondary"
      close
      close-icon="mdi-close"
      @click="open"
      @click:close="hideTrigger"
    )
      v-icon.mr-2 mdi-chevron-up-circle
      span Посмотреть инструкцию
    v-bottom-sheet(
      v-model="sheet"
      scrollable
      transition="help-transition"
    )
      .close-btn-wrapper
        v-chip.instruction__trigger-close(
          color="secondary"
          close
          close-icon="mdi-close"
          @click="close"
          @click:close="close"
        )
          span Закрыть
      v-card
        v-card-text.pt-5
          instruction-list(
            :show-item="id"
          )
</template>

<script>
import InstructionList from './InstructionList.vue';

export default {
  name: 'InstructionBottomSheet',
  components: {
    InstructionList,
  },
  props: {
    id: { type: Number, required: true },
  },
  data: () => ({
    sheet: false,
    instruction: null,
    triggerVisible: true,
  }),
  methods: {
    open() {
      this.sheet = true;
    },
    close() {
      this.sheet = false;
    },
    hideTrigger() {
      this.triggerVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.instruction {
  width: 100%;
  text-align: center;

  &__trigger-open {
    position: fixed;
    font-weight: bold;
    font-size: 0.9rem;
    height: 40px;
    bottom: 0;
    transform: translateX(-50%);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 1;
  }
  &__trigger-close {
    font-weight: bold;
    font-size: 0.9rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.close-btn-wrapper {
  position: absolute;
  width: 100%;
  text-align: center;
  transform: translateY(-100%);
}
</style>
